import { render, staticRenderFns } from "./ConversionShow.vue?vue&type=template&id=65e23b82&"
import script from "./ConversionShow.vue?vue&type=script&lang=ts&"
export * from "./ConversionShow.vue?vue&type=script&lang=ts&"
import style0 from "./ConversionShow.vue?vue&type=style&index=0&id=65e23b82&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports